export default {
  MyGallery: 'My Gallery',
  newWork: 'New Folder',
  newNmae: 'Rename',
  work: 'Folder Name',
  new: 'New',
  delWork: 'Delete Folder',
  deleteTip: 'This operation will permanently delete the file. Continue?',
  movecategory: 'Move Folder',
  isWork: 'Target Folder',
  workName: 'Image Name',
  UploadMaterial: 'Upload Material',
  uploadTip: 'Upload JPG/PNG images up to 20 MB',
  uploadSuccess: 'Upload successful',
  uploadFail: 'Upload failed',
  sFail: 'Some uploads failed',
  empty: 'No materials',
  empty1: 'No materials. Please upload images first.',
  empty2: 'No material selected',
  Filepath: 'File Path',
  FileSize: 'File Size',
  FileProportion: 'Aspect Ratio',
  UploadTime: 'Upload Time',
  updateTime: 'Modified Time',
  remark: 'Remarks',
  delTitle: 'Delete Folder Only',
  delTitles: 'Delete Folder and Images',
  delTitleTip: 'Delete only the folder and move its images to the default folder',
  Free: 'Free Crop',
  move: 'Move',
};
